export function replacer(key: any, value: any) {
    if (value instanceof Map) {
        return {
            dataType: "Map",
            value: Array.from(value.entries()),
        };
    } else {
        return value;
    }
}

export function reviver(key: any, value: any) {
    if (typeof value === "object" && value !== null) {
        if (value.dataType === "Map") {
            return new Map(value.value);
        }
    }
    return value;
}

export function stringifyWithMap(obj: any): string {
    return JSON.stringify(obj, replacer);
}

export function parseWithMap(json: string): any {
    return JSON.parse(json, reviver);
}
